/** A settings record value as form-field text (numbers and strings only). */
export function num(v: unknown): string {
  return typeof v === 'string' || typeof v === 'number' ? String(v) : '';
}
